import { BrowserOptions, NodeOptions, EdgeOptions } from '@sentry/nextjs';

import { ENV } from '@/environment/client';

// This file contains the Sentry base configuration shared across all environments.
const baseConfig = {
  // debug mode
  debug: false,
  // data source name
  dsn: ENV.NEXT_PUBLIC_SENTRY_DSN,
  // collect IP addresses
  sendDefaultPii: true,
  // transaction sampling disabled
  tracesSampleRate: 0,
} as BrowserOptions | NodeOptions | EdgeOptions;

export default baseConfig;
